import { useSyncExternalStore } from "react";

type Theme = "light" | "dark";
const key = "crate-theme";
const system = window.matchMedia("(prefers-color-scheme: dark)");
const listeners = new Set<() => void>();
let preference: Theme | null = null;
try {
  const saved = localStorage.getItem(key);
  if (saved === "light" || saved === "dark") preference = saved;
} catch {
  /* Storage can be unavailable in private or restricted browsers. */
}
let theme: Theme = preference ?? (system.matches ? "dark" : "light");

function apply() {
  document.documentElement.dataset.theme = theme;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", theme === "dark" ? "#151517" : "#ffffff");
  for (const listener of listeners) listener();
}
apply();
system.addEventListener("change", () => {
  if (preference) return;
  theme = system.matches ? "dark" : "light";
  apply();
});
window.addEventListener("storage", (event) => {
  if (event.key !== key && event.key !== null) return;
  preference =
    event.newValue === "light" || event.newValue === "dark"
      ? event.newValue
      : null;
  theme = preference ?? (system.matches ? "dark" : "light");
  apply();
});
export function toggleTheme() {
  theme = theme === "dark" ? "light" : "dark";
  preference = theme;
  try {
    localStorage.setItem(key, theme);
  } catch {
    /* Keep the toggle usable. */
  }
  apply();
}
export function useTheme() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    () => theme,
  );
}
